import React from 'react';
// @ts-ignore:next-line
import { CheckboxFilter } from '@folio/stripes/smart-components';
import { Headline } from '@folio/stripes/components';
import { t, isEditDisabled, isRefreshDisabled, isDeleteDisabled, isCancelRefreshDisabled, isCancelExportDisabled, isExportDisabled } from '../../../../services';
import { ActionMenu } from '../../../../components';
import { ICONS } from '../../../../interfaces';
export var ListInformationMenu = function (_a) {
    var stripes = _a.stripes, columns = _a.columns, visibleColumns = _a.visibleColumns, conditions = _a.conditions, buttonHandlers = _a.buttonHandlers, onColumnsChange = _a.onColumnsChange;
    var isExportInProgress = conditions.isExportInProgress, isRefreshInProgress = conditions.isRefreshInProgress;
    var cancelRefreshButton = {
        label: 'cancel-refresh',
        icon: ICONS.refresh,
        onClick: buttonHandlers['cancel-refresh'],
        disabled: isCancelRefreshDisabled(conditions)
    };
    var refreshButton = {
        label: 'refresh',
        icon: ICONS.refresh,
        onClick: buttonHandlers.refresh,
        disabled: isRefreshDisabled(conditions)
    };
    var initExportButton = {
        label: 'export',
        icon: ICONS.download,
        onClick: buttonHandlers["export"],
        disabled: isExportDisabled(conditions)
    };
    var cancelExportButton = {
        label: 'cancel-export',
        icon: ICONS.download,
        onClick: buttonHandlers['cancel-export'],
        disabled: isCancelExportDisabled(conditions)
    };
    var refreshSlot = isRefreshInProgress ? (cancelRefreshButton) : (refreshButton);
    var exportSlot = isExportInProgress ? cancelExportButton : initExportButton;
    var actionButtons = [];
    if (stripes.hasPerm("lists.item.refresh" /* USER_PERMS.RefreshList */)) {
        actionButtons.push(refreshSlot);
    }
    if (stripes.hasPerm("lists.item.update" /* USER_PERMS.UpdateList */)) {
        actionButtons.push({
            label: 'edit',
            icon: ICONS.edit,
            onClick: buttonHandlers.edit,
            disabled: isEditDisabled(conditions)
        });
    }
    if (stripes.hasPerm("lists.item.delete" /* USER_PERMS.DeleteList */)) {
        actionButtons.push({
            label: 'delete',
            icon: ICONS.trash,
            onClick: buttonHandlers["delete"],
            disabled: isDeleteDisabled(conditions)
        });
    }
    if (stripes.hasPerm("lists.item.export.get" /* USER_PERMS.ExportList */)) {
        actionButtons.push(exportSlot);
    }
    return (React.createElement(ActionMenu, { actionButtons: actionButtons },
        React.createElement(Headline, { size: "medium", margin: "none", tag: "p", faded: true }, t('pane.dropdown.show-columns')),
        React.createElement(CheckboxFilter
        // @ts-ignore:next-line
        , { 
            // @ts-ignore:next-line
            dataOptions: columns, name: "ui-lists-columns-filter", 
            // @ts-ignore:next-line
            onChange: onColumnsChange, selectedValues: visibleColumns })));
};
